(() => {
  if (customElements.get('product-dispatch-banner')) return;
  class ProductDispatchBanner extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: this.dataset.timezone, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
      const tomorrow = new Date(Date.UTC(parts.year, parts.month - 1, parts.day + 1));
      this.querySelector('[data-dispatch-date]').textContent = new Intl.DateTimeFormat('nb-NO', {
        timeZone: 'UTC', day: 'numeric', month: 'long'
      }).format(tomorrow);
      this.hidden = false;
    }
  }
  customElements.define('product-dispatch-banner', ProductDispatchBanner);
})();
